import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import ChartTableToggle from 'components/reporting/chart_table_toggle';
import { PillBar, PillButton } from 'components/reporting/reporting_shared_styled';

export default function ChartTabs({ charts }) {
  const [activeTab, setActiveTab] = useState(0);
  const chart = charts[activeTab];
  const hasDataset = chart.datasetColumns && chart.datasetRows && chart.datasetRows.length > 0;

  return (
    <ChartTabsContainer>
      <TabBar>
        {charts.map((c, idx) => (
          <PillButton $active={idx === activeTab} key={idx} onClick={() => setActiveTab(idx)} type="button">
            {c.title || `Chart ${idx + 1}`}
          </PillButton>
        ))}
      </TabBar>
      <ChartTableToggle
        chartSpec={chart.vegaConfig}
        data={hasDataset ? { columns: chart.datasetColumns, rows: chart.datasetRows } : null}
      />
    </ChartTabsContainer>
  );
}

ChartTabs.propTypes = {
  charts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const ChartTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const TabBar = styled(PillBar)`
  overflow-x: auto;
`;
